// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import Select from '../controls/Select'
import FilterDatepicker from '../controls/FilterDatepicker'
import _ from 'lodash'
import type { FilterParamsType, OptionType } from '../types'
import InputChangeWatcher from '../../services/callbacksDebouncer'
import StatisticFieldPopup from './CampaignFilterForm/StatisticFieldPopup'
import StatisticFilters from './CampaignFilterForm/StatisticFilters'

export const FiltersWrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  padding-bottom: 10px;
  width: 100%;
`
export const ElementWrapper: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  width: ${(props: Object) => props.width};
  margin-right: 10px;
`
const FilterLabelWrapper = styled.div`
  margin-top: 5px;
  padding: 3px 0;
  font-size: 12px;
  color: gray;
`
const StyledInput = styled.input`
  height: 35px;
  border: 1px solid #ccc;
  border-radius: 5px;
  text-align: left;
  padding: 0 15px;
  width: 100%;
`

const t = {
  active: 'Включена',
  all: 'Все',
  audience_activity_status_placeholder: 'Статус',
  audience_name_placeholder: 'Название',
  campaign_select_placeholder: 'Кампания',
  facebook: 'Facebook',
  google: 'Google',
  inactive: 'Выключена',
  provider_select_placeholder: 'Сеть',
  statistics_filter_placeholder: 'Статистика',
  submit: 'Применить',
  target_mail: 'myTarget',
  vk: 'ВКонтакте'
}

type Props = {|
  campaignOptions: Array<OptionType>,
  filterFormOrigin: string,
  dateSeparator: string,
  initialDate: string,
  filterParams: FilterParamsType,
  onChange: Function,
  onDatepickerChange: Function,
  statisticFields: Array<string>
|}

type State = {|
  audienceName: string,
  statisticField: string,
  isLoading: boolean,
  isPopupOpen: boolean
|}

export default class CampaignFilterForm extends Component<Props, State> {
  inputChangeWatcher: any

  constructor(props: Props) {
    super(props)

    this.state = {
      audienceName: props.filterParams.audienceName,
      statisticField: 'all',
      isLoading: false,
      isPopupOpen: false
    }

    this.inputChangeWatcher = new InputChangeWatcher(500)
    this.inputChangeWatcher.onChange(() => this.filterByInput())
  }

  render() {
    const { filterParams, statisticFields } = this.props
    const { audienceActivityStatus, campaignId, provider } = filterParams
    const { isLoading, audienceName, isPopupOpen, statisticField } = this.state
    return (
      <div>
        <FiltersWrapper>
          <ElementWrapper width="11%" className="t-ActivityStatusFilter">
            <FilterLabelWrapper>{t.audience_activity_status_placeholder}</FilterLabelWrapper>
            <Select
              disabled={isLoading}
              value={audienceActivityStatus}
              options={this.activityStatusOptions()}
              onChange={(audienceActivityStatus) => {
                this.changed({ ...filterParams, audienceActivityStatus })
              }}
            />
          </ElementWrapper>
          <ElementWrapper width="15%">
            <FilterLabelWrapper>{t.audience_name_placeholder}</FilterLabelWrapper>
            <StyledInput
              className="t-NameFilter"
              type="text"
              value={audienceName}
              disabled={isLoading}
              onChange={(e) => {
                this.setState({ audienceName: e.target.value })
                this.inputChangeWatcher.debouncedOnChange()
              }}
            />
          </ElementWrapper>
          <ElementWrapper width="15%" className="t-ProviderFilter">
            <FilterLabelWrapper>{t.provider_select_placeholder}</FilterLabelWrapper>
            <Select
              value={provider}
              options={this.providerOptions()}
              disabled={isLoading}
              onChange={(provider) => {
                this.changed({ ...filterParams, provider })
              }}
            />
          </ElementWrapper>
          <ElementWrapper width="20%" className="t-CampaignIdFilter">
            <FilterLabelWrapper>{t.campaign_select_placeholder}</FilterLabelWrapper>
            <Select
              value={campaignId}
              options={this.campaignOptions()}
              disabled={isLoading}
              onChange={(campaignId) => {
                this.changed({ ...filterParams, campaignId })
              }}
            />
          </ElementWrapper>
          <ElementWrapper width="15%" className="t-StatisticFieldsFilter">
            <FilterLabelWrapper>{t.statistics_filter_placeholder}</FilterLabelWrapper>
            <StatisticFieldPopup
              isPopupOpen={isPopupOpen}
              isLoading={isLoading}
              statisticField={statisticField}
              statisticFields={statisticFields}
              statisticFilters={filterParams.statisticFilters}
              onFilterChange={(statisticFilters) =>
                this.changed({ ...filterParams, statisticFilters })
              }
              onChange={(diff, callback) =>
                this.setState(diff, () => {
                  callback && callback()
                })
              }
            />
          </ElementWrapper>
          <FilterDatepicker
            initialDate={this.props.initialDate}
            separator={this.props.dateSeparator}
            origin={this.props.filterFormOrigin}
            disabled={isLoading}
            onChange={(datepicker) => {
              this.props.onDatepickerChange({ ...filterParams, datepicker }, () =>
                this.setState({ isLoading: false })
              )
            }}
          />
        </FiltersWrapper>
        <StatisticFilters
          statisticFilters={this.props.filterParams.statisticFilters}
          onFilterChange={(statisticFilters) => this.changed({ ...filterParams, statisticFilters })}
        />
      </div>
    )
  }

  activityStatusOptions() {
    return [
      { name: t.all, id: '' },
      { name: t.active, id: 'active' },
      { name: t.inactive, id: 'inactive' }
    ]
  }

  campaignOptions(): Array<OptionType> {
    return _.concat([{ name: t.all, id: '' }], this.props.campaignOptions)
  }

  providerOptions() {
    return [
      { name: t.all, id: '' },
      { name: t.vk, id: 'VK' },
      { name: t.target_mail, id: 'MT' },
      { name: t.facebook, id: 'FB' },
      { name: t.google, id: 'Google' }
    ]
  }

  renderOptions(options: Array<OptionType>): Array<any> {
    return _.map(options, (option) => {
      return (
        <option value={option.id} key={option.id}>
          {option.name}
        </option>
      )
    })
  }

  changed(diff: Object) {
    const { onChange } = this.props
    onChange && onChange({ filterParams: diff })
  }

  filterByInput() {
    const { audienceName } = this.state
    const { filterParams } = this.props
    this.changed({ ...filterParams, audienceName })
  }
}
